module.exports = __webpack_public_path__ + "fonts/Caveat-400-latin4.6376799.woff2";